<script>
    import * as userService from "./service.svelte.js";
    import BreadCrumNav from "../../components/breadcrum-nav.svelte";
    import V2List from "./_components/v2-list.svelte";
    import { format } from "svelte-i18n";
    //import LogoLoader from "../../components/logo-loader.svelte";
    import Spinner from "../../components/spinner.svelte";

    let loggedUser;
    let users;

    let usersPromise = userService.search();
    let userPromise = userService.getLoggedUser();

    let userCanAdd = userService.can("user", "add"); //if user can add, can also edit and delete

    let allPromises = $state(
        Promise.all([usersPromise, userPromise, userCanAdd])
            .then(([pUsers, pUser, pUserCanAdd]) => {
                users = pUsers;
                loggedUser = pUser;
                userCanAdd = pUserCanAdd;
                users.forEach((user) => {
                    user.label = $format(`page.user.roles.${user.role}`);
                });
                return {
                    users,
                    loggedUser,
                    userCanAdd,
                };
            })
            .catch((e) => {
                return {
                    users: [],
                    loggedUser: { show_user_add_msg: false },
                    userCanAdd: false,
                };
            }),
    );
    const handleTableRefresh = () => {
        let usersPromise = userService.search();
        let userPromise = userService.getLoggedUser();
        let userCanAdd = userService.can("user", "add");

        allPromises = Promise.all([usersPromise, userPromise, userCanAdd])
            .then(([pUsers, pUser, pUserCanAdd]) => {
                users = pUsers;
                loggedUser = pUser;
                userCanAdd = pUserCanAdd;
                users.forEach((user) => {
                    user.label = userService.roles[user.role];
                });
                return {
                    users,
                    loggedUser,
                    userCanAdd,
                };
            })
            .catch((e) => {
                return {
                    users: [],
                    loggedUser: { show_user_add_msg: false },
                    userCanAdd: false,
                };
            });
    };
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-users fa-xs"></i>
                    {$format("page.user.title")}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav
                    routes={[{ label: $format("page.user.title") }]}
                />
            </div>
        </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        {#await allPromises then data}
            <V2List
                data={data.users}
                loggedUser={data.loggedUser}
                userCanAdd={data.userCanAdd}
                on:add={handleTableRefresh}
                on:del={handleTableRefresh}
                on:edit={handleTableRefresh}
                on:tableRefresh={() => handleTableRefresh(true)}
            />
        {/await}
        {#await allPromises}
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <Spinner />
                    </div>
                </div>
            </div>
        {/await}
    </div>
</section>


